import { Stack } from '@landler/component-library';
import { useTranslation } from 'react-i18next';

import { Card } from '@/components/widgets/o/Card/Card';

export const ComingSoon = () => {
  const { t } = useTranslation();

  return (
    <Card styles={{ root: 'h-[400px] w-full rounded-2xl', body: 'h-full w-full' }}>
      <Stack spacing={4} center centerMain className='h-full w-full'>
        <Stack className='h-16 w-16 bg-secondary-12 rounded-full' center centerMain>
          <i className='ri-refresh-line text-3xl' />
        </Stack>
        <span className='typography-h3'>{t('global.misc.comingSoon')}</span>
      </Stack>
    </Card>
  );
};
